/**
 * Lightweight device fingerprint (Phase 2)
 * ~2kb, no external library, no PII bomb.
 *
 * Returns a stable SHA-256 hex string derived from browser attributes.
 * Sophisticated fraudsters can spoof this; casual fraudsters cannot.
 */
export async function computeDeviceFingerprint() {
  try {
    const parts = [
      navigator.userAgent || "",
      (navigator.languages || [navigator.language || ""]).join(","),
      `${window.screen.width}x${window.screen.height}x${window.screen.colorDepth}`,
      `${window.screen.availWidth}x${window.screen.availHeight}`,
      Intl.DateTimeFormat().resolvedOptions().timeZone || "",
      String(navigator.hardwareConcurrency || 0),
      String(navigator.maxTouchPoints || 0),
      navigator.platform || "",
      _canvasHash(),
    ];
    const seed = parts.join("|");
    const enc = new TextEncoder().encode(seed);
    const buf = await crypto.subtle.digest("SHA-256", enc);
    return Array.from(new Uint8Array(buf))
      .map((b) => b.toString(16).padStart(2, "0"))
      .join("");
  } catch (err) {
    return null;
  }
}

function _canvasHash() {
  try {
    const canvas = document.createElement("canvas");
    canvas.width = 200;
    canvas.height = 60;
    const ctx = canvas.getContext("2d");
    if (!ctx) return "";
    ctx.textBaseline = "top";
    ctx.font = "14px 'Arial'";
    ctx.fillStyle = "#f60";
    ctx.fillRect(0, 0, 60, 30);
    ctx.fillStyle = "#069";
    ctx.fillText("Eros fp 2026 ⚡", 2, 2);
    ctx.fillStyle = "rgba(102,204,0,0.7)";
    ctx.fillText("Eros fp 2026 ⚡", 4, 4);
    return canvas.toDataURL().slice(-64);
  } catch {
    return "";
  }
}
